<template>
  <admin-wrapper
    title-translation-path="admin.FAILURES"
    :inputs="inputs"
    :moduleEnabler="moduleEnabler"
    :is-form-fetched="isFormFetched"
    :has-buttons="failuresCutoffEnabled || failuresDispatcherEnabled"
    @save="saveCard"
  >
    <template #visualization.input>
      <predefined-styles class="mb-16" :layer-id="layerId" :data-source-name="dataSourceName"></predefined-styles>
    </template>
    <template #featureCard.input>
      <draggable-lists-manage-card
        :layer-id="layerId"
        @update:hasAnyRequiredOnRightSide="hasAnyRequiredOnRightSide = $event"
        :has-edit-attributes="true"
      >
      </draggable-lists-manage-card>
    </template>
  </admin-wrapper>
</template>

<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import DraggableListsManageCard from '@/components/DraggableListsManageCard';
import PredefinedStyles from '@/components/PredefinedStyles';

export default {
  name: 'FailuresSettings',
  components: {
    AdminWrapper,
    DraggableListsManageCard,
    PredefinedStyles,
  },
  data: () => ({
    isFormFetched: false,
    hasAnyRequiredOnRightSide: false,
  }),
  computed: {
    dataSourceName: get('admin/modulesMapping@failures.datasource_name'),
    isModuleEnabled: get('admin/settingsValues@failures_module_enabled'),
    layerId: get('admin/modulesMapping@failures.layer_id'),
    currentLayerSchema: get('layers/currentLayerSchema'),
    failuresCutoffEnabled: get('admin/settingsValues@failures_cutoff_enabled'),
    failuresDispatcherEnabled: get('admin/settingsValues@failures_dispatcher_enabled'),
    moduleEnabler() {
      return {
        name: 'failures_module_enabled',
        translationPath: 'admin.FAILURES',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.FAILURES') }),
      };
    },
    inputs() {
      return [
        ...(this.failuresCutoffEnabled
          ? [
              {
                name: 'cutoff_valves_label',
                disabled: !this.isModuleEnabled,
                dataType: {
                  name: 'text',
                },
                align: 'start',
                translationPath: 'admin.locksLabel',
                subtitle: `admin.locksLabelSubtitle`,
              },
            ]
          : []),
        ...(this.failuresDispatcherEnabled
          ? [
              {
                name: 'visualization',
                subtitle: `admin.failuresVisualizationSubtitle`,
                translationPath: 'admin.visualizationOnMap',
                isCustom: true,
                align: 'start',
              },
              {
                name: 'featureCard',
                clearable: true,
                translationPath: 'admin.featureCard',
                isCustom: true,
                subtitle: this.$i18n.t('admin.setFeatureCard', { type: this.$i18n.t('admin.objectType') }),
                align: 'start',
              },
            ]
          : []),
      ];
    },
  },
  methods: {
    getModulesMapping: call('admin/getModulesMapping'),
    getDataSourceForm: call('layers/getDataSourceForm'),
    getLayerMetadata: call('layers/getLayerMetadata'),
    getFeaturesLayer: call('layers/getFeaturesLayer'),
    editLayer: call('layers/editLayer'),
    async saveCard() {
      await this.editLayer({
        layer_type: 'features_layers',
        layer_id: this.layerId,
        body: {
          form_schema: {
            elements: this.currentLayerSchema,
          },
        },
      });
    },
    async init() {
      await this.getModulesMapping();
      if (this.failuresDispatcherEnabled) {
        await Promise.all([
          this.getDataSourceForm(this.dataSourceName),
          this.getFeaturesLayer(this.layerId),
          this.getLayerMetadata({ dataSource: this.dataSourceName }),
        ]);
      }
      this.isFormFetched = true;
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFormFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
};
</script>
